<template>
  <div
    :class="{
      'justify-center': true,
      'overflow-hidden': scrollable,
      'px-3xl': true,
      'w-screen': true,
      flex: true,
    }"
  >
    <div class="grid w-[1920px] max-w-[1920px] grid-cols-3 gap-lg">
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts" setup>
type ContainerGridProps = {
  scrollable?: boolean;
};
defineProps<ContainerGridProps>();
</script>
